import React, { useState, useEffect } from 'react';

import { Modal, Button } from "react-bootstrap";

const ModalInfo = ({title, information, eventaData}) => {

    const [show, setShow] = useState(false);

    const handleClose = () =>  { setShow(false); eventaData({})};
    const handleShow = () => setShow(true);

    useEffect(() => {     
        const show = () => { handleShow() }
        if(title || information){ show() }
    }, [title, information])
    return ( 
        <>          
            <Modal
                animation={false}
                size="lg"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: information}} />
                </Modal.Body>
                <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}>
                    Cerrar
                </Button>
               
                </Modal.Footer>
            </Modal>
        </>
     );
}
 
export default ModalInfo;